// import colors from './colors';

const ThemeBuilder = {
  textBlock: {
    primary: {
      classes: `text-on-primary [&_a]:text-accents-primary`
    },
    secondary: {
      classes: `text-on-secondary`
    },
    variant: {
      classes: `text-on-variant [&_a]:text-accents-primary`
    },
    error: {
      classes: `text-on-error`
    },
    disabled: {
      classes: `text-on-disabled`
    }
  },
  button: {
    primary: {
      classes: 'bg-accents-primary text-accents-on-primary hover:shadow-button'
                + ' active:bg-accents-secondary active:shadow-none'
                + ' disabled:bg-surface-container-accent disabled:text-on-disabled disabled:shadow-none disabled:opacity-60',
    },
    secondary: {
      classes: 'text-accents-primary hover:bg-surface-secondary-container active:text-accents-secondary'
               + ' disabled:bg-transparent disabled:text-on-disabled disabled:opacity-60'
    },
  },

  getBorderRadii: (radiusInput: string) => {
    if(!radiusInput)
      return '';

    const radiusInputArray = radiusInput.split(' ');
    let radiusClasses = '';

    radiusInputArray.forEach((radius, index) => {
      switch (index) {
        case 0: 
          if(radius !== "0" && radius.toLowerCase() !== "none")
            radiusClasses = `rounded-tl-${radius}`
          break;
        case 1: 
          if(radius !== "0" && radius.toLowerCase() !== "none")
          radiusClasses = `${radiusClasses} rounded-tr-${radius}`
          break;
        case 2: 
          if(radius !== "0" && radius.toLowerCase() !== "none")
            radiusClasses = `${radiusClasses} rounded-br-${radius}`
          break;
        case 3: 
          if(radius !== "0" && radius.toLowerCase() !== "none")
            radiusClasses = `${radiusClasses} rounded-bl-${radius}`
          break;
        default:
          break;
      }
    })

    radiusClasses = radiusClasses.replace("  ", " ").trim();

    return radiusClasses;
  }
};

export default ThemeBuilder;
